import React from "react";
import * as Redux from 'react-redux';
import { Button } from 'semantic-ui-react';

import TopMenu from './TopMenu';
import * as pageActions from './../actions/pageActions';

export class NotFound extends React.Component {
	constructor(props) {
		super(props);
		const {dispatch} = this.props;

		dispatch(pageActions.setPage(window.location.pathname + window.location.search));
	}

	componentDidMount() {
		document.title = "404 - Page Not Found";
	}

	render() {
		var {dispatch} = this.props;
		
		return (
			<div>
				<TopMenu />
				<div className="not-found-page">
					<h2>Page Not Found</h2>
					<Button primary onClick={e => {
						dispatch(pageActions.setRedirectTo("/"));
					}}>Back to Home</Button>
					<p>If you continue to get this page, please contact us at <a href="mailto:support@yougotlistings.com" target="_blank" rel="noopener noreferrer">support@yougotlistings.com</a></p>
				</div>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(NotFound);


// WEBPACK FOOTER //
// ./src/components/NotFound.js